/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event', {
            parent: 'board.dinghy',
            url: '/event?pageE&sortE&searchE&archiveE&typeE',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyEvent.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/event/dinghy-events.html',
                    controller: 'DinghyEventBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                pageE: {
                    value: '1',
                    squash: true
                },
                sortE: {
                    value: 'fromDate,asc',
                    squash: true
                },
                archiveE: {
                    value: 'false',
                    squash: true
                },
                typeE: {
                    value: 'all',
                    squash: true
                },
                searchP: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        pageE: PaginationUtil.parsePage($stateParams.pageE),
                        sortE: $stateParams.sortE,
                        predicateE: PaginationUtil.parsePredicate($stateParams.sortE),
                        ascendingE: PaginationUtil.parseAscending($stateParams.sortE),
                        searchE: $stateParams.searchE,
                        archiveE: $stateParams.archiveE,
                        typeE: $stateParams.typeE
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.new', {
            parent: 'board.dinghy.event',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyEvent.home.createLabel'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-dialog.html',
                    controller: 'DinghyEventBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                type: null,
                                fromDate: null,
                                untilDate: null,
                                contactEmail: null,
                                placeCount: null,
                                location: null,
                                identifier: 'jollensegeln',
                                normalPrice: null,
                                studentPrice: null,
                                guestPrice: null,
                                description: null,
                                conditions: null,
                                notes: null,
                                visible: false,
                                active: false,
                                closed: false,
                                canceled: false,
                                allowGuests: true,
                                allowQueue: true,
                                individualQuestion: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('board.dinghy.event');
                });
            }]
        })
        .state('board.dinghy.event.self-assign', {
            parent: 'board.dinghy.event',
            url: '/self-assign/{id}',
            data: {
                authorities: ['ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-assign-dialog.html',
                    controller: 'DinghyEventAssignController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.cancel', {
            parent: 'board.dinghy.event',
            url: '/{id}/cancel',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-cancel-dialog.html',
                    controller: 'DinghyEventBoardCancelController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.delete', {
            parent: 'board.dinghy.event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-delete-dialog.html',
                    controller: 'DinghyEventBoardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
